export default "__VITE_ASSET__b84e62cd__"